module.exports = __webpack_public_path__ + "static/media/gliding_snow.3a2f4fa8.svg";